import { TJsonQuery } from '../../../../packages/JsonQuery';
import { TReduxActions } from '../../actions';
import { EFetchMapDataActionType } from '../../actions/fetchMapData/types';
import { ENonGeoParametersActionTypes } from '../../actions/nonGeoParameters';

export interface INonGeoParametersState {
  nonGeoOffersCount: number | null | undefined;
  nonGeoJsonQuery: TJsonQuery | null | undefined;
  hasNoneGeoParametersBeenSet: boolean;
}

const initialState: INonGeoParametersState = {
  nonGeoOffersCount: null,
  nonGeoJsonQuery: null,
  hasNoneGeoParametersBeenSet: false,
};

export function nonGeoParametersReducer(state = initialState, action: TReduxActions): INonGeoParametersState {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      const { nonGeoOffersCount, nonGeoJsonQuery } = action.payload;

      return { ...state, nonGeoOffersCount, nonGeoJsonQuery: nonGeoJsonQuery as TJsonQuery };
    }
    case ENonGeoParametersActionTypes.Set: {
      return { ...state, hasNoneGeoParametersBeenSet: action.payload };
    }
    default:
      return state;
  }
}
